import { render, staticRenderFns } from "./MzAudio.vue?vue&type=template&id=2dcfa4d8&scoped=true&"
import script from "./MzAudio.vue?vue&type=script&lang=js&"
export * from "./MzAudio.vue?vue&type=script&lang=js&"
import style0 from "./MzAudio.vue?vue&type=style&index=0&id=2dcfa4d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcfa4d8",
  null
  
)

export default component.exports